import React from 'react';
import css from './Section.module.css';
import howItWorksImage1 from '../../../assets/howItWorks1.jpg';
import howItWorksImage2 from '../../../assets/howItWorks2.jpg';
import howItWorksImage3 from '../../../assets/howItWorks3.png';
import howItWorksImage4 from '../../../assets/howItWorks4.jpg';
import { PrimaryButton } from '../../../components';
import { useHistory } from 'react-router-dom';

function SectionHowItWorks(props) {
  const { intl } = props;
  const history = useHistory();

  const data = [
    {
      img: howItWorksImage1,
      titleId: 'SectionHowItWorks.step1.title',
      descriptionId: 'SectionHowItWorks.step1.description',
    },
    {
      img: howItWorksImage2,
      titleId: 'SectionHowItWorks.step2.title',
      descriptionId: 'SectionHowItWorks.step2.description',
    },
    {
      img: howItWorksImage3,
      titleId: 'SectionHowItWorks.step3.title',
      descriptionId: 'SectionHowItWorks.step3.description',
    },
    {
      img: howItWorksImage4,
      titleId: 'SectionHowItWorks.step4.title',
      descriptionId: 'SectionHowItWorks.step4.description',
    },
  ];

  return (
    <div className={css.howItWorkSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.sectionHead}>
          <h2>
            {intl.formatMessage({
              id: 'SectionHowItWorks.title',
              defaultMessage: 'How It Works',
            })}
          </h2>
          <p>
            {intl.formatMessage({
              id: 'SectionHowItWorks.subtitle',
              defaultMessage:
                'A seamless journey from discovery through transaction and transfer. Chevalier provides experienced support every step of the way.',
            })}
          </p>
        </div>

        <div className={css.howItWorkContent}>
          {data.map((dataItem, index) => {
            const stepTitle = intl.formatMessage({
              id: dataItem.titleId,
              defaultMessage: '',
            });

            return (
              <div className={css.moreInfoBlock} key={dataItem.titleId}>
                <div className={css.infoImg}>
                  <span className={css.count}>{index + 1}</span>
                  <img src={dataItem.img} alt={stepTitle} />
                </div>

                <h4>
                  {intl.formatMessage({
                    id: dataItem.titleId,
                    defaultMessage: '',
                  })}
                </h4>

                <p>
                  {intl.formatMessage({
                    id: dataItem.descriptionId,
                    defaultMessage: '',
                  })}
                </p>
              </div>
            );
          })}
        </div>

        <div className={css.startExplore}>
          <PrimaryButton 
          onClick={() => {
           history.push('/s');
          }}
          >
            {intl.formatMessage({
              id: 'SectionHowItWorks.cta',
              defaultMessage: 'START EXPLORING BARRELS',
            })}
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
}

export default SectionHowItWorks;
